/** Add methods that will be called to set varibles in redux store state */

import {
  CLEAR_ERROR,
  CONVERSATION_SELECTED,
  SET_ERROR,
  UPDATE_CONVERSATION_LOG,
  STATUS_CODE,
  USER_NAME,
  CLIENT_MESSAGE_FUNC,
  OPERATOR_WATCHLIST,
  CENTER_STATUS_LIST,
  CALL_TAKEN,
  CENTER_LIST,
  STATUS_LIST,
  CENTER_LIST_CALLHISTORY,
  STATUS_LIST_CALLHISTORY,
  CALL_RECORD,
  SUCCESS_CALL_STATUS,
  CNETR_NAME,
  CENTER_PREFIX,
  CALL_SOURCE,
  MOBILE_NUMBER,
  RESPONSE_OF_CALL,
  CLEAR_CONVERSATION_ID,
  DATA_CAME_FROM_BACKEND,
  CLEAR_CENTER_NAME,
  DATA_IS_LOADING,
  OPERATOR_CENTER_LIST,
  FETCHING_REFERRAL_FORM,
  INITIATE_WEBSOCKET,
  INTERNET_CONNECTION_STATUS,
  WEBSOCKET_CONNECTION_STATE,
  RETRY_TO_CONNECT_WEBSOCKET_IN_SEC,
  BOT_ERROR,
  ORDER_SCAN_DETAILS,
  SCAN_EXAM_LIST,
  GOT_ERROR_IN_HELP_NOTES,
  CUSTOMER_LIST,
  DIRECT_CALL_STATIC_DATA,
  SCAN_LIST,
  CLIENT_IP
} from "./actionTypes";

export const SetSelectedWorkdeskConversation = ({
  conversation_id,
  caller_id,
  center_name,
  referral_form_status,
  initial_time,
  statusCode,
  center_prefix,
  center_id,
  client_ip
}) => ({
  type: CONVERSATION_SELECTED,
  payload: {
    conversation_id: conversation_id,
    caller_id: caller_id,
    center_name: center_name,
    referral_form_status: referral_form_status,
    initial_time: initial_time,
    statusCode: statusCode,
    center_prefix: center_prefix,
    center_id,
    client_ip
  },
});

export const UpdateConversationLog = (data) => ({
  type: UPDATE_CONVERSATION_LOG,
  payload: {
    conversation_log: data,
  },
});

export const SetError = ({ severity, message }) => ({
  type: SET_ERROR,
  payload: {
    severity,
    message,
  },
});

export const ClearError = () => ({
  type: CLEAR_ERROR,
  payload: {},
});

export const StatusCode = (code) => ({
  type: STATUS_CODE,
  payload: code,
});

export const UserName = ({ name, email }) => ({
  type: USER_NAME,
  payload: { name, email },
});

export const ClientMessageFunc = (func) => ({
  type: CLIENT_MESSAGE_FUNC,
  payload: func,
});

export const OperatorWatchListFun = (data) => ({
  type: OPERATOR_WATCHLIST,
  payload: data,
});

export const CenterCallStatusFunc = (data) => ({
  type: CENTER_STATUS_LIST,
  payload: data,
});

export const CallTakenByOperatorFunc = (data) => ({
  type: CALL_TAKEN,
  payload: data,
});

export const centerListFunc = (data) => ({
  type: CENTER_LIST,
  payload: data,
});

export const statusListFunc = (data) => ({
  type: STATUS_LIST,
  payload: data,
});

export const centerListCallHistoryFunc = (data) => ({
  type: CENTER_LIST_CALLHISTORY,
  payload: data,
});

export const statusListCallHistoryFunc = (data) => ({
  type: STATUS_LIST_CALLHISTORY,
  payload: data,
});

export const callRecordFunc = (data) => ({
  type: CALL_RECORD,
  payload: data,
});

export const successCallStatusListFunc = (list) => ({
  type: SUCCESS_CALL_STATUS,
  payload: list,
});

export const centerSelectFunc = (centerName) => ({
  type: CNETR_NAME,
  payload: centerName,
});
export const centerPreFixFunc = (centerName) => ({
  type: CENTER_PREFIX,
  payload: centerName,
});

export const CallSourceFunc = (CallSource) => ({
  type: CALL_SOURCE,
  payload: CallSource,
});

export const MobileNumberFunc = (mobile_number) => ({
  type: MOBILE_NUMBER,
  payload: mobile_number,
});

export const ResposneOfCallFunc = (response) => ({
  type: RESPONSE_OF_CALL,
  payload: response,
});

export const clearConversationIdFunc = () => ({
  type: CLEAR_CONVERSATION_ID,
});

export const setDataFetchingStatus = (response) => ({
  type: DATA_CAME_FROM_BACKEND,
  payload: response,
});

export const clearCenterNameFunc = () => ({
  type: CLEAR_CENTER_NAME,
});

export const showingLoadingBarFunc = (showLoadingbar) => ({
  type: DATA_IS_LOADING,
  payload: showLoadingbar,
});

export const setAssignedCenterList = (centerList) => ({
  type: OPERATOR_CENTER_LIST,
  payload: centerList,
});


export const setIsReferralFormfetchingFunc = (isReferralFetching) => ({
  type: FETCHING_REFERRAL_FORM,
  payload:isReferralFetching
  
})
export const setWebSocketFunc = (websocket) => ({
  type: INITIATE_WEBSOCKET,
  payload: websocket,
});

export const setInternetConnectionStatusFunc = (internetStatus) => ({
  type: INTERNET_CONNECTION_STATUS,
  payload: internetStatus,
});

export const setWebSocketConnectionStateFunc = (webSocketState) => ({
  type: WEBSOCKET_CONNECTION_STATE,
  payload: webSocketState,
});

export const setWilltryToConnectWebSocketFunc = (sec) => ({
  type: RETRY_TO_CONNECT_WEBSOCKET_IN_SEC,
  payload: sec,
});


export const setBotErrorList=(data)=>({
  type:BOT_ERROR,
  payload:data,

});

export const setScanOrderDetails=(data)=>({
  type:ORDER_SCAN_DETAILS,
  payload:data
})

export const setScanExamList=(scan)=>({
  type:SCAN_EXAM_LIST,
  payload:scan
})

export const setHelpNotesGotAnError=(status)=>({
  type:GOT_ERROR_IN_HELP_NOTES,
  payload:status
})

export const setCustomersDetails=(data)=>({
  type:CUSTOMER_LIST,
  payload:data,
})


export const setDirectCallStaticData=(data)=>({
  type:DIRECT_CALL_STATIC_DATA,
  payload:data,
})

export const setScanList=(data)=>({
  type:SCAN_LIST,
  payload:data,
})

export const setClientIp=(data)=>({
  type:CLIENT_IP,
  payload:data,
})